import { MatPaginatorIntl } from '@angular/material';

export class MatPaginatorIntlIt extends MatPaginatorIntl {
  itemsPerPageLabel = 'risultati per pagina';
  nextPageLabel = 'pagina successiva';
  previousPageLabel = 'pagina precedente';

  getRangeLabel = function(page, pageSize, length) {
    if (length === 0 || pageSize === 0) {
      return '0 di ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' di ' + length;
  };

}



// WEBPACK FOOTER //
// ./src/app/helpers/mat-paginator-intl-IT.ts